<div class="flex flex-col text-lightMode-800 dark:text-darkMode-100 bg-lightCardBG dark:bg-darkCardBG min-w-[15rem]">
    <div [class]="this.data.classStyle ?? ''" class="w-full px-8 py-6 flex flex-wrap justify-center items-center">
        <mat-icon aria-hidden="true" data-mat-icon-type="font"  class="size-auto flex items-center justify-center rtl:ml-2 ltr:mr-2 text-5xl" [class]="data.succesful?'text-green-500':'text-red-500'">
            {{data.succesful?'verified':'report'}}
        </mat-icon>
        <div class="text-center" [innerHTML]="data?.message|convertToPersian">
        </div>
    </div>
    <div *ngIf="(data?.checkButton ?? true) && data.buttons.length!=0" class="flex px-5 py-3 bg-lightMode-200 dark:bg-darkMode-700 w-full justify-center">
        <button (click)="emit(item)" *ngFor="let item of data.buttons" matRipple matDialogClose class="mx-3 px-3 py-2 h-[40px] min-w-[70px] rounded-md bg-lightCardBG dark:bg-darkCardBG text-lightMode-800 dark:text-darkMode-100 text-center flex items-center justify-center">
            {{item.buttonText}}
        </button>
    </div>
</div>
